import React from 'react';
import Lottie from 'lottie-react-web';
import animation from './loading.json';
import './styles.scss';

export default function Loading({ height, width }) {
    return (
        <div className="loading">
            <Lottie
                options={{
                    animationData: animation,
                }}
                width={height}
                height={width}
            />
        </div>
    );
}
